import React from "react";
import BlogThirtyThree from "../component/BlogThirtyThree";

function BlogThirtyThreeContainer() {
  return <BlogThirtyThree />;
}
export default BlogThirtyThreeContainer;
